
import React, { useReducer } from 'react';
import tabReducer from '../reducers/tabReducer';
const TabStateContext = React.createContext();
const TabDispatchContext = React.createContext();

export { TabStateContext, TabDispatchContext };

export default function TabProvider({ children }) {
  const [state, dispatch] = useReducer(tabReducer, { activeTab: 'first' });
  return (
    <TabDispatchContext.Provider value={dispatch}>
      <TabStateContext.Provider value={state}>
        {children}
      </TabStateContext.Provider>
    </TabDispatchContext.Provider>
  );
};
